import { render, staticRenderFns } from "./CreateLoanOfficerAssignment.vue?vue&type=template&id=b8f9d9a2&scoped=true&"
import script from "./CreateLoanOfficerAssignment.vue?vue&type=script&lang=js&"
export * from "./CreateLoanOfficerAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f9d9a2",
  null
  
)

export default component.exports